import type { BatchChanged, BatchMetadata } from '../components/BatchMetadataFields'

/** The server's PhotoBulkInput: only the fields the user ticked "change" on. */
export interface PhotoBulkInput {
  addTagIds?: string[]
  removeTagIds?: string[]
  buildingId?: string | null
  floorId?: string | null
  trade?: string | null
  folderId?: string
  visibility?: 'PROJECT' | 'INTERNAL'
}

export const ZIP_MAX_IDS = 400 // the ids travel in the URL

export const bulkInputFrom = (value: BatchMetadata, changed: BatchChanged, tags: { add: string[]; remove: string[] }): PhotoBulkInput => {
  const input: PhotoBulkInput = {}
  if (changed.folderId && value.folderId) input.folderId = value.folderId
  if (changed.buildingId) input.buildingId = value.buildingId || null
  if (changed.floorId) input.floorId = value.floorId || null
  if (changed.trade) input.trade = value.trade || null
  if (changed.visibility) input.visibility = value.visibility
  if (changed.tagIds) {
    if (tags.add.length > 0) input.addTagIds = tags.add
    if (tags.remove.length > 0) input.removeTagIds = tags.remove
  }
  return input
}

/** Tag ids carried by every photo of the selection. */
export const commonTagIds = (tagIdLists: string[][]): string[] =>
  tagIdLists.length === 0 ? [] : tagIdLists[0].filter((id) => tagIdLists.every((l) => l.indexOf(id) >= 0))

/** The picker starts at the common tags: whatever is chosen is added, whatever was common and got dropped is removed. */
export const tagDelta = (common: string[], chosen: string[]): { add: string[]; remove: string[] } => ({
  add: chosen,
  remove: common.filter((id) => chosen.indexOf(id) < 0),
})

export const photosZipUrl = (projectId: string, ids: string[]): string =>
  `/download/photos/${encodeURIComponent(projectId)}?ids=${ids.map(encodeURIComponent).join(',')}`

/** Right-click acts on the selection when the photo is part of it, else the photo becomes the selection (file-manager convention). */
export const contextSelection = (selected: Set<string>, photoId: string): Set<string> =>
  selected.has(photoId) ? selected : new Set([photoId])
